/**
 * Conservative heuristic to detect whether a pasted plain-text string is likely markdown.
 * We keep this strict to avoid converting normal prose that happens to include symbols.
 *
 * @param {string} text
 */
export const looksLikeMarkdown = (text = "") => {
  const t = String(text).replace(/\r\n/g, "\n");
  const s = t.trim();
  if (!s) return false;

  // Headings: "# Title"
  if (/^\s{0,3}#{1,6}\s+\S/m.test(t)) return true;

  // Blockquote: "> quote"
  if (/^\s{0,3}>\s+\S/m.test(t)) return true;

  // Unordered list: "- item", "* item", "+ item"
  if (/^\s{0,3}[-*+]\s+\S/m.test(t)) return true;

  // Ordered list: "1. item"
  if (/^\s{0,3}\d+\.\s+\S/m.test(t)) return true;

  // Link: [text](url)
  if (/\[[^\]]+\]\([^)]+\)/.test(t)) return true;

  // Horizontal rule: "---", "***", "___"
  if (/^\s{0,3}([-*_])\1\1+\s*$/m.test(t)) return true;

  return false;
};


